import { exportRecipes } from './exportRecipes';

export default {
  exportRecipes,
};
